import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { OperatorEnum } from '../../../../shared/ui/OperatorUtil';
import { LABELSTYLE } from '../../../../shared/ui/Constants';
import { AuthService } from '../../../../shared/service/auth-service/auth-service.service';
import { ListColumn, ListDataColumn } from '../../../../shared/ui/Data/ListColumn';

export class FieldDefinitionConditions {
  constructor(private injector: Injector) { }

  queryInboxConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'receiver',
      type: 'conditionQueryLookupInputType',
      hide: (!this.injector.get(AuthService).isEMAOrganisation()),
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'Receiver ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        } 
      }
    },
    {
      className: 'flex-1',
      key: 'sender',
      type: 'conditionQueryLookupInputType',
      hide: (!this.injector.get(AuthService).isEMAOrganisation()),
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'Sender ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'File Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'Acknowledgement Message Number',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'receiveDate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'Receive Date',
        conditionType: OperatorEnum.OperatorEqual
      }
    },
    {
      className: 'flex-1',
      key: 'receiveDateFrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'Receive Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan
      }
    },
    {
      className: 'flex-1',
      key: 'receiveDateUpTo',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryInboxConditions'],
        label: 'Receive Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan
      }
    }

  ];

  queryOutboxConditions: FormlyFieldConfig[] = [

    {
      className: 'flex-1',
      key: 'sender',
      type: 'conditionQueryLookupInputType',
      hide: (!this.injector.get(AuthService).isEMAOrganisation()),
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'Sender ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        } 
      }
    },
    {
      className: 'flex-1',
      key: 'receiver',
      type: 'conditionQueryLookupInputType',
      hide: (!this.injector.get(AuthService).isEMAOrganisation()),
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'Receiver ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        } 
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'File Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'Message Number',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'sendDate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'Send Date',
        conditionType: OperatorEnum.OperatorEqual
      }
    },
    {
      className: 'flex-1',
      key: 'sendDateFrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'Send Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan
      }
    },
    {
      className: 'flex-1',
      key: 'sendDateUpTo',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryOutboxConditions'],
        label: 'Send Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan
      }
    }
  
  ];

  queryToEudravigilanceConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'receiver',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'Receiver ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      }
    },
    {
      className: 'flex-1',
      key: 'sender',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'Sender ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'File Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'Message Number',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'receiveDate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'Receive Date',
        conditionType: OperatorEnum.OperatorEqual
      }
    },
    {
      className: 'flex-1',
      key: 'receiveDateFrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'Receive Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan
      }
    },
    {
      className: 'flex-1',
      key: 'receiveDateUpTo',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryToEudravigilance'],
        label: 'Receive Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan
      }
    }

  ];

  queryFromEudravigilanceConditions: FormlyFieldConfig[] = [
    {
      className: 'flex-1',
      key: 'sender',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'Sender ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      }
    },
    {
      className: 'flex-1',
      key: 'receiver',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'Receiver ID',
        isfreetext: false,
        lookup: {
          name: 'senderid',
          description: 'Search for Eudravigilance IDs of organisations registered with Eudravigilance',
          columns: [
            new ListColumn('Num', ListDataColumn.TEXT, 'num'),
            new ListColumn('EV ID', ListDataColumn.TEXT, 'code'),
            new ListColumn('Name', ListDataColumn.TEXT, 'name'),
            new ListColumn('Country', ListDataColumn.TEXT, 'countryname'),
            new ListColumn('Connection', ListDataColumn.TEXT, 'trading'),
            new ListColumn('Type', ListDataColumn.TEXT, 'organisationevtype'),
            new ListColumn('EV Profile Type', ListDataColumn.TEXT, 'evprofile'),
          ],
          type: 'R',
          disableToggle: true
        }
      }
    },
    {
      className: 'flex-1',
      key: 'code',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'File Name',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'name',
      type: 'conditionQueryLookupInputType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'Acknowledgement Message Number',
        isfreetext: true 
      }
    },
    {
      className: 'flex-1',
      key: 'sendDate',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'Send Date',
        conditionType: OperatorEnum.OperatorEqual
      }
    },
    {
      className: 'flex-1',
      key: 'sendDateFrom',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'Send Date (From)',
        conditionType: OperatorEnum.OperatorGreaterEqualsThan
      }
    },
    {
      className: 'flex-1',
      key: 'sendDateUpTo',
      type: 'conditionQueryDatetimeType',
      props: {
        labelstyle: LABELSTYLE['queryFromEudravigilance'],
        label: 'Send Date (Up to)',
        conditionType: OperatorEnum.OperatorLowerEqualsThan
      }
    }

  ];
  
}

